export default __webpack_public_path__ + "static/media/Kat Kun Stick Chicken Flavour.6c9090a7.png";